import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[520px] md:h-[680px] overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Dark%20moody%20cityscape%20at%20night%20with%20warm%20red%20and%20amber%20neon%20lights%2C%20rain%20on%20asphalt%2C%20reflections%2C%20cinematic%20atmosphere%2C%20modern%20Chinese%20urban%20night%20scene%2C%20mysterious%20vibe%2C%20high%20contrast%2C%20professional%20photography%2C%20no%20people%2C%20warm%20dark%20tones%20with%20crimson%20and%20golden%20accents&width=1800&height=900&seq=hero-bg-main&orientation=landscape"
        alt="每日吃瓜 - 最新娱乐爆料"
        className="absolute inset-0 w-full h-full object-cover object-top animate-fade-in"
        title="每日吃瓜 - 最新娱乐爆料平台"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/60"></div>

      <div className="relative z-10 w-full h-full flex items-center">
        <div className="w-full px-4 md:px-6">
          <div className="flex flex-col lg:flex-row items-start lg:items-end justify-between gap-8">
            <div className="flex-1 max-w-2xl">
              <div className="flex items-center gap-3 mb-6 animate-fade-in-up animate-delay-100" style={{ opacity: 0 }}>
                <div className="flex -space-x-2">
                  {['#e85d75', '#f4a261', '#2a9d8f'].map((color, i) => (
                    <div
                      key={i}
                      className="w-9 h-9 rounded-full border-2 border-white/80 flex items-center justify-center text-white text-xs font-bold"
                      style={{ backgroundColor: color }}
                    >
                      {['吃', '瓜', '人'][i]}
                    </div>
                  ))}
                </div>
                <span className="text-white/80 text-sm">500万+ 瓜友在线</span>
              </div>

              <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-white leading-tight animate-fade-in-up animate-delay-200" style={{ opacity: 0 }}>
                最新<span className="text-primary-400">吃瓜</span>爆料
                <br />
                <span className="font-light text-white/80">实时追踪不迷路</span>
              </h1>

              <p className="mt-4 text-white/70 text-sm md:text-base max-w-lg leading-relaxed animate-fade-in-up animate-delay-300" style={{ opacity: 0 }}>
                聚合全网最新网红爆料、明星八卦、聊天记录泄露等内幕资讯，每日更新，吃瓜不停。
              </p>

              <div className="animate-fade-in-up animate-delay-400" style={{ opacity: 0 }}>
                <Link
                  to="/category/zuixin-chigua"
                  className="mt-6 inline-flex items-center gap-2 bg-white text-foreground-900 px-6 py-3 rounded-full text-sm font-medium hover:bg-primary-50 transition-colors cursor-pointer whitespace-nowrap"
                >
                  立即吃瓜
                  <i className="ri-arrow-right-circle-line text-lg"></i>
                </Link>
              </div>
            </div>

            <div className="hidden lg:block text-right animate-slide-in-right animate-delay-500" style={{ opacity: 0 }}>
              <p className="text-white/60 text-sm leading-relaxed max-w-xs">
                每日吃瓜聚合全网热点，为你提供最及时的娱乐八卦和网红爆料，让你不错过任何一个大瓜。
              </p>
            </div>
          </div>
        </div>
      </div>

      <div className="absolute bottom-6 left-1/2 -translate-x-1/2 z-10">
        <div className="w-6 h-10 rounded-full border-2 border-white/40 flex items-start justify-center p-1.5">
          <div className="w-1 h-2.5 bg-white/60 rounded-full animate-bounce"></div>
        </div>
      </div>
    </section>
  );
}